export interface CaseStudyStat {
  value: string
  label: string
}

export interface CaseStudy {
  vertical: string
  market: string
  summary: string
  stats: CaseStudyStat[]
}

export const caseStudies: CaseStudy[] = [
  {
    vertical: 'Windows & Doors',
    market: 'Western US',
    summary:
      '250+ hires at a 64.4% hire rate, 3 new markets, +$2M in new revenue.',
    stats: [
      { value: '388', label: 'Interviews' },
      { value: '250+', label: 'Hires' },
      { value: '64.4%', label: 'Hire rate' },
    ],
  },
  {
    vertical: 'Roofing',
    market: 'Nationwide Expansion',
    summary:
      '100+ hires at a 50%+ hire rate, scaled from a 4-market pilot to all 12 campaigns.',
    stats: [
      { value: '200+', label: 'Interviews' },
      { value: '100+', label: 'Hires' },
      { value: '50%+', label: 'Hire rate' },
    ],
  },
  {
    vertical: 'Life Insurance',
    market: 'Senior Benefits',
    summary: '101 hires at a 70.1% hire rate, for a cost-per-hire under $200.',
    stats: [
      { value: '144', label: 'Interviews' },
      { value: '101', label: 'Hires' },
      { value: '70.1%', label: 'Hire rate' },
    ],
  },
  {
    vertical: 'Telecom',
    market: 'California',
    summary:
      "89.6% hire rate, named the organization's single preferred recruiting source.",
    stats: [
      { value: '89.6%', label: 'Hire rate' },
      { value: '#1', label: 'Preferred source' },
      { value: '~0', label: 'Wasted interviews' },
    ],
  },
  {
    vertical: 'Remodeling',
    market: 'North Carolina',
    summary: '59 hires at a 73.8% hire rate, opening a brand new market.',
    stats: [
      { value: '80', label: 'Interviews' },
      { value: '59', label: 'Hires' },
      { value: '73.8%', label: 'Hire rate' },
    ],
  },
  {
    vertical: 'Community Solar',
    market: 'Midwest',
    summary:
      '35+ hires every month at a 70% hire rate, under $250 cost-per-hire.',
    stats: [
      { value: '50+', label: 'Interviews / mo' },
      { value: '35+', label: 'Hires / mo' },
      { value: '70%', label: 'Hire rate' },
    ],
  },
  {
    vertical: 'Roofing',
    market: 'Atlanta',
    summary: '57 hires at a 66.3% hire rate, for a cost-per-hire under $225.',
    stats: [
      { value: '86', label: 'Interviews' },
      { value: '57', label: 'Hires' },
      { value: '66.3%', label: 'Hire rate' },
    ],
  },
  {
    vertical: 'Deregulated Energy',
    market: 'Northeast',
    summary:
      '15 hires a month at a 75% hire rate, powering 2 new market launches.',
    stats: [
      { value: '20 / mo', label: 'Interviews' },
      { value: '15 / mo', label: 'Hires' },
      { value: '75%', label: 'Hire rate' },
    ],
  },
]
